/** Service Desk limits, timers and CSAT: mirror of backend `app/core/constants/service_desk_limits.py`.
 *  Generated once from the backend constants; `tests/core/test_service_desk_mirror.py` keeps the two equal. */

export const TICKET_TITLE_MIN = 5 as const;

export const TICKET_TITLE_MAX = 140 as const;

export const TICKET_DESCRIPTION_MAX = 10000 as const;

export const TICKET_MESSAGE_MAX = 10000 as const;

export const TICKET_REQUEST_BODY_MAX_BYTES = 262144 as const;

export const TICKET_TAGS_MAX = 20 as const;

export const TICKET_TAG_LENGTH_MAX = 32 as const;

export const TICKET_ASSETS_MAX = 10 as const;

export const TICKET_CHILDREN_MAX = 20 as const;

export const TICKET_BULK_MAX = 100 as const;

export const TICKET_MERGE_BULK_MIN = 2 as const;

export const TICKET_MERGE_BULK_MAX = 10 as const;

export const TICKET_NUMBER_START = 10001 as const;

export const TICKET_NUMBER_PREFIX_PATTERN = "^[A-Z]{2,5}$" as const;

export const TICKET_NUMBER_PREFIX_LETTERS = 3 as const;

export const TYPE_NAME_MIN = 2 as const;

export const TYPE_NAME_MAX = 60 as const;

export const TYPE_FIELDS_MAX = 40 as const;

export const TYPE_INTAKE_GUIDANCE_MAX = 1000 as const;

export const FIELD_KEY_MAX = 40 as const;

export const FIELD_LABEL_MAX = 80 as const;

export const FIELD_HELP_MAX = 200 as const;

export const FIELD_TEXT_MAX = 500 as const;

export const FIELD_LONG_TEXT_MAX = 5000 as const;

export const FIELD_DROPDOWN_OPTIONS_MAX = 100 as const;

export const FIELD_MULTI_SELECT_OPTIONS_MAX = 50 as const;

export const FIELD_FILES_MAX = 5 as const;

export const ORGANISATION_NAME_MIN = 2 as const;

export const ORGANISATION_NAME_MAX = 160 as const;

export const ORGANISATION_CODE_MAX = 16 as const;

export const ORGANISATION_EMAIL_DOMAINS_MAX = 10 as const;

export const ORGANISATION_TIER_MAX = 40 as const;

export const ORGANISATION_NOTES_MAX = 4000 as const;

export const ORGANISATION_TIN_MAX = 20 as const;

export const CONTACT_NAME_MAX = 120 as const;

export const CONTACT_JOB_TITLE_MAX = 80 as const;

export const IMPORT_ROWS_MAX = 20000 as const;

export const IMPORT_FILE_MAX_BYTES = 10485760 as const;

export const ATTACHMENTS_PER_MESSAGE_MAX = 10 as const;

export const ATTACHMENT_IMAGE_PDF_MAX_MB = 20 as const;

export const ATTACHMENT_VIDEO_MAX_MB = 50 as const;

export const ATTACHMENT_VIDEO_MAX_SECONDS = 60 as const;

export const ATTACHMENTS_PER_TICKET_MAX_MB = 500 as const;

export const ATTACHMENT_SIGNED_GET_MAX_SECONDS = 300 as const;

export const ATTACHMENT_MIME_ALLOWLIST = ["image/jpeg", "image/png", "image/webp", "image/heic", "application/pdf", "video/mp4", "video/quicktime", "text/plain", "text/csv"] as const;

export const TIMER_UNASSIGNED_MINUTES = 15 as const;

export const TIMER_WAITING_REMINDER_DAYS = [3, 6] as const;

export const TIMER_AUTO_RESOLVE_DAYS = 10 as const;

export const TIMER_AUTO_CLOSE_DAYS = 5 as const;

export const TIMER_AUTO_CLOSE_DAYS_RANGE = [1, 30] as const;

export const TIMER_VISIT_REMINDER_CLIENT_DAYS_BEFORE = 1 as const;

export const TIMER_VISIT_REMINDER_CLIENT_AT = "08:00" as const;

export const TIMER_VISIT_REMINDER_ENGINEER_HOURS_BEFORE = 2 as const;

export const TIMER_MAINTENANCE_LEAD_DAYS = 30 as const;

export const TIMER_WARRANTY_NOTICE_DAYS = 60 as const;

export const TIMER_CONTRACT_NOTICE_DAYS = 60 as const;

export const TIMER_APPROVAL_EXPIRY_DAYS = 7 as const;

export const TIMER_TICK_SECONDS = 60 as const;

export const FOLLOW_UP_WINDOW_DAYS = 30 as const;

export const REDACTED_ORIGINAL_RETENTION_DAYS = 30 as const;

export const SOFT_DELETE_PURGE_DAYS = 30 as const;

export const EMAIL_BURST_BATCH_MINUTES = 5 as const;

export const MAGIC_LINK_TTL_MINUTES = 15 as const;

export const TICKET_RETENTION_YEARS_DEFAULT = 5 as const;

export const TICKET_RETENTION_YEARS_RANGE = [1, 10] as const;

export const CSAT_SCORE_MIN = 1 as const;

export const CSAT_SCORE_MAX = 5 as const;

export const CSAT_REASON_MAX_SCORE = 3 as const;

export const CSAT_LOW_SCORE_MAX = 2 as const;

export const CSAT_COMMENT_MAX = 1000 as const;

export const CSAT_LINK_EXPIRY_DAYS = 14 as const;

export const CSAT_FATIGUE_DAYS_DEFAULT = 7 as const;

export const CSAT_FATIGUE_DAYS_RANGE = [0, 30] as const;

export const CSAT_ALERT_THRESHOLD_DEFAULT = 2 as const;

export const CSAT_ALERT_THRESHOLD_RANGE = [1, 4] as const;

export const CSAT_RECENT_DEFAULT = 10 as const;

export const CSAT_RECENT_MAX = 50 as const;

export const CSAT_REASONS = ["Took too long", "Not resolved", "Engineer communication", "Parts availability", "Other"] as const;
